/*
 * @Author: WUJUN
 * @Date: 2019-07-09 11:52:34
 * @LastEditTime: 2021-10-13 16:40:13
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import Cookies from 'js-cookie';
import store from '../store';

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (String(time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
export function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = '';
  if (window.location.search) {
    r = window.location.search.substr(1).match(reg);
  } else if (window.location.href.includes('#')) {
    r = window.location.href.split('#')[1].match(reg);
  }

  if (r !== null && r !== '') return unescape(r[2]);
  return '';
}

export function formatTime(time, option) {
  time = Number(time) * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

// 防抖动函数
export function debounce(method, context, parameters) {
  clearTimeout(method.timeout);
  method.timeout = setTimeout(function() {
    method.call(context, parameters);
  }, 300);
}

// 简单的节流函数
export function throttle(func, wait, mustRun) {
  let timeout,
    startTime = new Date();

  return function() {
    let context = this,
      args = arguments,
      curTime = new Date();

    clearTimeout(timeout);
    // 如果达到了规定的触发时间间隔,触发 handler
    if (curTime - startTime >= mustRun) {
      func.apply(context, args);
      startTime = curTime;
      // 没达到触发间隔,重新设定定时器
    } else {
      timeout = setTimeout(func, wait);
    }
  };
}
// 深拷贝
export function deepClone(obj) {
  const objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        // 判断ojb子元素是否为对象,如果是,递归复制
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = deepClone(obj[key]);
        } else {
          // 如果不是,简单复制
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

//存储localStorage
export const setStore = (name, content) => {
  if (!name) return;
  localStorage.setItem(name, JSON.stringify(content));
};

//获取localStorage
export const getStore = (name) => {
  if (!name) return;
  return JSON.parse(localStorage.getItem(name));
};

export function removeSpace(value) {
  return value.replace(/\s+/g, '');
}

export function formValidate(val, type) {
  let phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/,
    emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
  if (val === '') {
    return false;
  } else {
    //非空验证
    if (type === 'require') {
      return !!removeSpace(val);
    }
    if (type === 'phone') {
      return phoneReg.test(val);
    }
    if (type === 'email') {
      return emailReg.test(val);
    }
  }
}

//数组去重
export function dedupe(array) {
  return Array.from(new Set(array));
}

//去除重复对象
export function dedupeObject(obj) {
  let uniques = [];
  let stringify = {};
  for (let i = 0; i < obj.length; i++) {
    let keys = Object.keys(obj[i]);
    keys.sort(function(a, b) {
      return Number(a) - Number(b);
    });
    let str = '';
    for (let j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(obj[i][keys[j]]);
    }
    if (!stringify.hasOwnProperty(str)) {
      uniques.push(obj[i]);
      stringify[str] = true;
    }
  }
  uniques = uniques;
  return uniques;
}
export function getName() {
  if (Cookies.get('CUID')) {
    let arr = Cookies.get('CUID').split('-');
    let uid = arr[0];
    let name = arr[1];
    return { uid, name };
  } else if (Cookies.get('PIC')) {
    let val = Cookies.get('PIC');
    let arr = val.split('_');
    if (arr.length > 1) {
      arr.splice(0, 1);
      let value = arr.join('').split('-');
      let uid = value[0];
      let name = value[1];
      return { uid, name };
    } else {
      let value = val.split('_')[val.split('_').length - 1];
      let arr = value.split('-');
      let uid = arr[0];
      let name = arr[1];
      return { uid, name };
    }
  }
}

//获取接入渠道 通用key 进行区分 下单来源
export function getSource() {
  let val = getQueryString('key');
  console.log('val---------------: ', val);
  if (val) {
    store.commit('SET_KEY', val);
  }
}

// js通过创建input实现复制内容
export function copyContent(content) {
  const oInput = document.createElement('textarea');
  oInput.id = 'copyAlipayVal';
  oInput.value = content;
  document.body.appendChild(oInput);
  oInput.select();
  document.execCommand('Copy');
  oInput.style.display = 'none';
  document.body.removeChild(oInput);
}

/** 
  @list 需要操作的数组
  @key 时间字段key
  @type 排序方式：1=》由新到旧
*/
export function sortByTime(list = [], key = 'createTime', type = 1) {
  // ios不支持中划线-链连接的时间，转为 /
  const formatTime = (str) => {
    return str.replace(/-/g, '/');
  };
  return list.sort((a, b) => {
    const first = new Date(formatTime(a[key])),
      next = new Date(formatTime(b[key]));
    return type === 1 ? next - first : first - next;
  });
}

/** 
  刷新当前页
*/
export function reloadPage() {
  window.location.reload();
}

/*
 * 版本号比较方法
 * 传入两个字符串，当前版本号：curV；比较版本号：reqV
 * 调用方法举例：compare("1.1","1.2")，将返回false
 */
export function compareVersion(curV, reqV) {
  if (curV && reqV) {
    //将两个版本号拆成数字
    let arr1 = curV.split('.'),
      arr2 = reqV.split('.');
    let minLength = Math.min(arr1.length, arr2.length),
      position = 0,
      diff = 0;
    //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
    while (position < minLength && (diff = parseInt(arr1[position]) - parseInt(arr2[position])) === 0) {
      position++;
    }
    diff = diff !== 0 ? diff : arr1.length - arr2.length;
    //若curV大于reqV，则返回true
    return diff > 0;
  } else {
    //输入为空
    console.log('版本号不能为空');
    return false;
  }
}

/**
 * 判断 H5 是否运行在微信小程序 web-view 中
 * @returns {boolean}
 */
export function isInMiniProgramWebView() {
  if (typeof window === 'undefined') return false;

  // 官方环境变量（基础库 2.7.0+）
  if (typeof window.__wxjs_environment !== 'undefined') {
    return window.__wxjs_environment === 'miniprogram';
  }

  // 极端兼容：检测 UA（不推荐，仅作兜底）
  const ua = navigator.userAgent;
  return /(?:miniProgram|micromessenger)/i.test(ua) && !/windows phone/i.test(ua);
}



// WEBPACK FOOTER //
// src/utils/index.js